__turbopack_context__.v({
  "animatedInputLabelStyles": "styles-module__HghvRa__animatedInputLabelStyles",
  "blinkCaret": "styles-module__HghvRa__blinkCaret",
  "blinkCaretAnimation": "styles-module__HghvRa__blinkCaretAnimation",
  "initialLabelText": "styles-module__HghvRa__initialLabelText" + " " + "styles-module__HghvRa__blinkCaretAnimation" + " " + "styles-module__HghvRa__animatedInputLabelStyles",
  "initialLabelText--caretVisible": "styles-module__HghvRa__initialLabelText--caretVisible",
  "input--suggestionsVisible": "styles-module__HghvRa__input--suggestionsVisible",
  "inputLabel": "styles-module__HghvRa__inputLabel",
  "labelText": "styles-module__HghvRa__labelText" + " " + "styles-module__HghvRa__animatedInputLabelStyles",
  "rotatingLabelText": "styles-module__HghvRa__rotatingLabelText" + " " + "styles-module__HghvRa__blinkCaretAnimation" + " " + "styles-module__HghvRa__animatedInputLabelStyles",
  "rotatingLabelText--caretVisible": "styles-module__HghvRa__rotatingLabelText--caretVisible",
  "rotatingLabelText--visible": "styles-module__HghvRa__rotatingLabelText--visible",
  "searchBarInputWrapper": "styles-module__HghvRa__searchBarInputWrapper",
  "typingInOut": "styles-module__HghvRa__typingInOut",
  "typingOut": "styles-module__HghvRa__typingOut",
});
